<template>
  <NuxtLink
    :to="link"
    class="group flex flex-col gap-6 no-underline"
    :class="{ 'lg:flex-row lg:items-stretch lg:gap-12': large }"
  >
    <div
      v-if="img"
      class="h-52 overflow-hidden rounded-lg bg-white"
      :class="[large ? 'lg:h-auto lg:w-2/5' : 'w-full']"
    >
      <img
        :src="
          img.filename
            ? `${img.filename}/m/720x0/smart/`
            : `https://a-us.storyblok.com/f/1005128/1920x1080/bd4b8cf922/og-image.jpg/m/720x0/smart/`
        "
        alt=""
        class="h-full w-full object-cover object-center"
      />
    </div>

    <div :class="{ 'lg:w-3/5': large }">
      <div v-if="category" class="tag" v-html="category"></div>
      <h3 class="!normal-case group-hover:underline" v-html="title"></h3>
      <div class="my-4 max-w-screen-md">
        <p v-if="author" class="text-sm">By {{ author }}</p>
        <p
          class="!mb-4 text-base"
          v-html="
            desc ? `${desc.substring(0, large ? 240 : 120)}...` : 'Read more...'
          "
        ></p>
        <p class="text-sm text-grey-600">
          {{ date }} |
          <span
            >{{
              Math.floor(desc.split(" ").length / 200) === 0
                ? 1
                : Math.floor(desc.split(" ").length / 200)
            }}
            min read</span
          >
        </p>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
  large?: boolean;
  link: string;
  img?: { filename?: string };
  category?: string;
  title: string;
  author?: string;
  desc: string;
  date: string;
}>();

const date = computed(() =>
  new Date(props.date).toLocaleDateString("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }),
);
</script>
